
module.config(function($stateProvider) {

    $stateProvider.state('settings', {
        abstract: true,
        parent: 'basic',
        url: '/settings',
        templateUrl: 'settings/base',
    });

    $stateProvider.state('settings.index', {
        url: '',
        templateUrl: 'settings/index',
        controller: function($state, Principal) {
            var perms = Principal.permissions;
            if (!(perms.viewUsers ||
                  perms.editInitiativeTypes ||
                  perms.editGrantYears ||
                  perms.administerSystem)) {
                $state.go('settings.user');
            }
        },
    });


    $stateProvider.state('settings.scorecard', {
        url: '/scorecard',
        permission: 'administerScorecard',
        defaultChild: 'settings.scorecard.manage',
        templateUrl: 'empty',
    });

    $stateProvider.state('settings.scorecard.manage', {
        templateUrl: 'settings/scorecard/manage',
        controller: 'ScorecardManageSettingsController',
        controllerAs: '$ctrl',
        data: {title: 'Manage Fiscal Scorecard'},
        resolve: {
            sections: function(ScorecardService) {
                return ScorecardService.loadSections();
            },
        }
    });

    $stateProvider.state('settings.scorecard.section', {
        templateUrl: 'settings/scorecard/section',
        url: '/section-{sectionId:int}',
        controller: 'ScorecardSectionSettingsController',
        controllerAs: '$ctrl',
        resolve: {
            section: function($stateParams, ScorecardService) {
                return ScorecardService.loadSection($stateParams.sectionId);
            },
            questions: function($stateParams, ScorecardService) {
                return ScorecardService.loadQuestions($stateParams.sectionId);
            },
        }
    });

    $stateProvider.state('settings.scorecard.question', {
        url: '/question-{questionId:int}',
        templateUrl: 'settings/scorecard/question',
        controller: 'ScorecardQuestionSettingsController',
        controllerAs: '$ctrl',
        resolve: {
            question: function($stateParams, ScorecardService) {
                return ScorecardService.getConfigItem(
                    'question', $stateParams.questionId);
            },
            validConditions: function(question, ScorecardService) {
                return ScorecardService.indexConfigItem('question', {
                    section_id: question.section_id,
                    with_options: true,
                });
            },
            section: function(question, ScorecardService) {
                return ScorecardService.getConfigItem(
                    'section', question.section_id);
            },
        }
    })
});
